import React, { useState, useEffect, Fragment } from 'react';
import {
    IconButton,
    Typography,
    CssBaseline,
    Button,
    Container,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    DialogTitle,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@material-ui/core';
import {
    makeStyles,
    createStyles,
    withStyles,
    WithStyles,
} from '@material-ui/core/styles';

import { useHistory } from 'react-router-dom';
import axios from 'axios';

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';

import { COLORS } from './Theme';
import { SIcon } from './Icon';
import clsx from 'clsx';

import {
    member as v_member,
    basic,
    Values,
    SNACKBAR_TIME,
} from '../request/values';

import { DialogConfirm, DialogCompanyApproval } from './Dialog';
import useFixedButtonStyles from "./commonStyles/headerEmpty/useFixedButtonStyles";

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    paper: {
        // marginTop: theme.spacing(8),
        // marginTop: '6vh',
        height: '75vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    image: {
        width: '100%',
        textAlign: 'center',
        '& img': {
            width: '50%',
            maxWidth: '180px'
        },
    },
    form: {
        marginTop: '2vh',
        width: '72vw',
        // maxHeight: '40vh',
        // overflowY: 'auto',

        maxHeight: '40vh',
        [theme.breakpoints.up("md")]: {
          width: "100%"
        },
    },
    formTitle: {
      display: 'flex', 
      width: '70vw',
      [theme.breakpoints.up("md")]: {
        width: "100%"
      }, 
    },
    title: {
        color: `${COLORS.CHARCOAL_GREY}`,
        fontSize: 20,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        flex: 1,
    },
    list: {
        width: '100%',
        paddingBottom: '5px',
        paddingRight: '3px',
        // overflowY: 'scroll',
        // maxHeight: '35vh',
    },
    radioButton: {
        height: '4.75vh',
        width: '100%',
        // margin: theme.spacing(3, 0, 2),
        margin: 0,
        marginTop: '2vh',
        borderRadius: '10px',
        background: `${COLORS.VERY_LIGHT_PINK}`,
        // boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        // border: 'solid 0.5px #cfd4d9',
        '& span > div > p': {
            // paddingRight : '7vw',
            // paddingLeft: '4vw',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`,
        },
        '& .MuiFormControlLabel-label': {
            width: '70%',
        },
        '& #CEO': {
            ...theme.typography.body1,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            margin: 'auto 0',
            color: `${COLORS.BROWNISH_GREY}`,
        },
        '& #type': {
            ...theme.typography.body1,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            margin: 'auto 0',
            color: `${COLORS.BROWNISH_GREY}`,
        },
        // color: `${COLORS.WATER_BLUE}`,

        // '& span.Mui-checked' : {
        //     backgroundColor: `${COLORS.WATER_BLUE}`,
        //     button : {
        //         backgroundColor: `${COLORS.WATER_BLUE}`,
        //     }
        // }
    },
    button: {
        height: 60,
        width: '100%',
        // margin: theme.spacing(3, 0, 2),
        margin: 0,
        marginTop: '2vh',
        borderRadius: '27px',
        background: `${COLORS.GREEN}`,
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.16)',
        // border: 'solid 0.5px #cfd4d9',
        '& span': {
            // paddingRight : '7vw',
            // paddingLeft: '4vw',
        },
        '& .MuiFormControlLabel-label': {
            width: '70%',
        },
        // color: `${COLORS.WATER_BLUE}`,

        // '& span.Mui-checked' : {
        //     backgroundColor: `${COLORS.WATER_BLUE}`,
        //     button : {
        //         backgroundColor: `${COLORS.WATER_BLUE}`,
        //     }
        // }
    },
    checked: {
        backgroundColor: `${COLORS.BROWNISH_GREY}`,
    },
    radio: {
        paddingLeft: '6.5%',
        '&.Mui-checked': {
            '&, & + .MuiFormControlLabel-label #companyNum': {
                color: `${COLORS.WHITE}!important`,
            },
            '&, & + .MuiFormControlLabel-label #CEO': {
                color: `${COLORS.WHITE}!important`,
            },
            '&, & + .MuiFormControlLabel-label #type': {
                color: `${COLORS.WHITE}!important`,
            },
        },
    },
    buttonSection: {
        width: '84vw',
        marginTop: '3vh',
        [theme.breakpoints.up("md")]: {
          width: "100%"
        },
    },
    logoSection: {
        // position: 'absolute',
        // bottom: '5vh',
        // left: 0,
        // width: '100%',
        // textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        flex: 1,
        alignItems: 'flex-end',
        marginTop: '4vh',
    },
    dialog: {},
}));

type iCompany = {
    company_num: number;
    company_name: string;
    company_type: string;
    member_name: string;
};

const CompanyList: React.FC<any> = (props) => {
    const classes = useStyles();
    const fixedButtonClasses = useFixedButtonStyles();

    let history = useHistory();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { member, setMember } = props;

    const [company, setCompany] = useState<iCompany[]>([]);
    const [radio, setRadio] = useState<string>('');
    const [dialog, setDialog] = useState<boolean>(false);

    // const { member, setMember } = useMember();

    // const handleButton = () => {
    //     const member = getMember();
    //     console.log('click button')

    //     axios({
    //         method: "POST",
    //         data: {
    //             classCode: classCode,
    //             email: member.id,
    //         },
    //         withCredentials: true,
    //         url: SERVER + v_member.member + v_member.class_enter,
    //     }).then((res) => { return res.data })
    //         .then((data: any) => {
    //             console.log(data)
    //             if (data.code == Values.SUCCESS_CODE) {
    //                 setMember(Object.assign(member, { classCode: classCode }))
    //                 history.push({
    //                     pathname: '/companyAction',
    //                 });
    //             } else {
    //                 if (data.code == Values.FAIL_CODE) {
    //                     enqueueSnackbar(ToastStr.JOIN_FAIL_STR, { variant: "warning" })
    //                 } else {
    //                     enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error" })
    //                 }
    //             }
    //         })
    // }

    const action = (key: any) => (
        <Fragment>
            <Button
                onClick={() => {
                    closeSnackbar(key);
                }}
            >
                Close
            </Button>
        </Fragment>
    );

    const getCompanyList = () => {
        let url = new URL(SERVER + v_member.member + v_member.company_list);
        let params = { classCode: member.classCode.toString() };
        url.search = new URLSearchParams(params).toString();
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    setCompany((prevState) => data.companies);
                }
            });
    };

    const postCompanyApp = (grade: string) => {
        axios({
            method: 'POST',
            data: {
                companyNum: parseInt(radio),
                email: member.id,
                grade: grade,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.company_app,
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_APP_SUCCESS_STR, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    // setMember(...member, {companyNum : -1})
                    // setMember((prevState:any) => ...prevState, {companyNum : -1})

                    console.log(Object.assign({}, member, { companyNum: -1 }));
                    setMember(Object.assign({}, member, { companyNum: -1 }));

                    history.push({
                        pathname: '/CompanyAppStandBy',
                    });
                } else {
                    if (
                        data.code === Values.FAIL_CODE &&
                        data.msg.code === 'ER_DUP_ENTRY'
                    ) {
                        enqueueSnackbar(ToastStr.COMPANY_APP_DUPLICATE_STR, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else if (data.code == Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.COMPANY_APP_FAIL_STR, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                            variant: 'error',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    }
                }
            });
        handleClose();
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadio((prevState) => (event.target as HTMLInputElement).value);
    };

    const handleRefresh = () => {
        getCompanyList();
    };

    const handleButton = (event: any) => {
        if (radio != '') {
            handleOpen();
        }
    };

    const handleClose = () => {
        // console.log('close')
        setDialog((prevState) => !prevState);
    };

    const handleOpen = () => {
        // console.log('open')
        if (!dialog) {
            setDialog((prevState) => !prevState);
        }
    };

    const dialogYes = () => {
        // console.log('Yes')
        // postMaterialOrder()
    };

    const dialogNo = () => {
        // console.log('No')
        handleClose();
    };

    const find = () => {
        if (company && radio != '') {
            const f = company.find(
                (item) => item.company_num.toString() === radio
            );
            if (f !== undefined) return f.company_name;
        }
    };
    const findType = () => {
        if (company && radio != '') {
            const f = company.find(
                (item) => item.company_num.toString() === radio
            );
            if (f !== undefined) return f.company_type;
        }
    };

    useEffect(() => {
        getCompanyList();
    }, []);

    return (
        <div>
            <div className={fixedButtonClasses.fixedButton}>
            <IconButton
                onClick={() => history.goBack()}
            >
                <SIcon type="Back" />
            </IconButton>
            </div>
            <div className={classes.paper}>
                <div className={classes.image}>
                    <img width="45vw" src="/images/building_green.webp" />
                    <Typography
                        variant="h1"
                        style={{
                            color: `${COLORS.BROWNISH_GREY}`,
                            fontFamily: 'NanumR',
                        }}
                    >
                        지원할 새싹기업을 선택해주세요.
                    </Typography>
                </div>

                <div className={classes.form}>
                    <div className={classes.formTitle}>
                        <Typography className={classes.title}>
                            설립된 새싹기업 목록
                        </Typography>
                        <IconButton
                            style={{ padding: 0 }}
                            onClick={(e) => handleRefresh()}
                        >
                            <SIcon type="Refresh_Black" />
                        </IconButton>
                    </div>

                    <div style={{ maxHeight: '37vh', overflowY: 'auto' }}>
                        <FormControl component="fieldset" fullWidth>
                            <RadioGroup
                                className={classes.list}
                                value={radio}
                                onChange={handleChange}
                            >
                                {company != null &&
                                    company.map((item: any) => {
                                        return (
                                            <FormControlLabel
                                                className={clsx(
                                                    classes.radioButton,
                                                    radio ==
                                                        item.company_num.toString() &&
                                                        classes.checked
                                                )}
                                                value={item.company_num.toString()}
                                                control={
                                                    <Radio
                                                        className={
                                                            classes.radio
                                                        }
                                                    />
                                                }
                                                label={
                                                    <CompanyFormList
                                                        companyName={
                                                            item.company_name
                                                        }
                                                        CEO={item.member_name}
                                                        type={item.company_type}
                                                    />
                                                }
                                                // label={<div>item.company_name</div>}
                                            />
                                        );
                                    })}
                            </RadioGroup>
                        </FormControl>
                    </div>
                </div>
                <div className={classes.buttonSection}>
                    <Button
                        fullWidth
                        className={classes.button}
                        onClick={handleButton}
                    >
                        <Typography
                            variant="h3"
                            style={{
                                color: `${COLORS.WHITE}`,
                                fontFamily: 'NanumB',
                            }}
                        >
                            선택한 새싹기업 함께하기
                        </Typography>
                    </Button>
                </div>
            </div>
            <div style={{ flex: 1 }}></div>
            <div className={classes.logoSection}>
                <SIcon type="P" />
            </div>
            <DialogCompanyApproval
                open={dialog}
                handleClose={handleClose}
                title={'해당 기업에 지원하시겠습니까?'}
                memberName={member.name}
                companyName={find()}
                companyType={findType()}
                yesConfirm={postCompanyApp}
                noConfirm={handleClose}
            />
            {/* <Dialog
                className={classes.dialog}
                open={dialog} onClose={handleClose}
                PaperProps={{
                    style: {
                        borderRadius: 12,
                        boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                        backgroundColor: `${COLORS.WHITE}`,
                        width: '84vw',
                        maxWidth : 400,
                        height: '25vh',
                        maxHeight: 300,
                    }
                }}
            >
                <DialogTitle style={{ textAlign: 'center' }}><SIcon type={'Dialog'} /></DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography variant='h4' style={{ textAlign: 'center', marginRight: 3, color: `${COLORS.CHARCOAL_GREY}` }}>{find()}</Typography>
                    </DialogContentText>

                    <DialogContentText>
                        <Typography variant='h3' style={{ textAlign: 'center', color: `${COLORS.CHARCOAL_GREY}` }}>기업에 지원하시겠습니까?</Typography>
                    </DialogContentText>

                </DialogContent>

                <DialogActions style={{ justifyContent: 'center' }}>
                    <Button onClick={postCompanyApp}>완료</Button>
                    <Button onClick={handleClose} >취소</Button>
                </DialogActions>
            </Dialog> */}
        </div>
    );
};

const CompanyFormList: React.FC<any> = (props) => {
    const { companyName, CEO, type } = props;

    return (
        <div style={{ display: 'flex', width: '100%' }}>
            <Typography
                variant='body1'
                id="companyNum"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1,
                }}
            >
                {companyName}
            </Typography>

            <div>
                <Typography id="type" style={{ fontSize: '1vw' }}>
                    기업유형 : {type}
                </Typography>

                <Typography id="CEO" style={{ fontSize: '1vw', margin: '0' }}>
                    대표 : {CEO}
                </Typography>
            </div>
        </div>
    );
};

export default CompanyList;
